import { PRESENTLEVELS_EVENT_NAMES } from '@/presentlevels/event_names.ts'
import { TEXT_EDITOR_EVENTS } from '@/components/editor/event_names.ts'
import { RESOURCE_EVENTS } from '@/resources/event_names.ts'
import { LIBRARY_EVENT_NAMES } from '@/library/library_event_names.ts'
import { IMPACT_OF_DISABILITY_EVENT_NAMES } from '@/impact-of-disability/event_names.ts'
import { GOAL_INDEX_EVENT_NAMES } from '@/goalindex/event_names.ts'
import { UDL_INDEX_EVENT_NAMES } from '@/strategies/udlindex/event_names.ts'
import { BROWSE_STRATEGIES_EVENT_NAMES, STRATEGY_WIZARD_EVENT_NAMES } from '@/strategies/event_names.ts'

export const EVENT_NAMES = {
  PRESENTLEVELS: { ...PRESENTLEVELS_EVENT_NAMES },
  TEXT_EDITOR: { ...TEXT_EDITOR_EVENTS },
  RESOURCES: { ...RESOURCE_EVENTS },
  MISC: {
    COPIED_TEXT: 'Copied Text'
  }, 
  LIBRARY: { ...LIBRARY_EVENT_NAMES },
  IMPACT_OF_DISABILITY: { ...IMPACT_OF_DISABILITY_EVENT_NAMES },
  GOAL_INDEX: { ...GOAL_INDEX_EVENT_NAMES },
  UDL_INDEX: { ...UDL_INDEX_EVENT_NAMES },
  BROWSE_STRATEGIES: { ...BROWSE_STRATEGIES_EVENT_NAMES },
  STRATEGY_WIZARD: { ...STRATEGY_WIZARD_EVENT_NAMES },
}